import React, { useState} from "react";
import { motion } from "framer-motion";
import "./Navber.css";
import logo from "../../Assets/dhanushdhari_final_log.jpeg";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
   const { isAuthenticated, user } = useSelector((state) => state.auth);

  const scrollToSection = (id) => {
    setOpen(false);

    const section = document.getElementById(id);
    if (!section) return;

    // Scroll smooth
    window.scrollTo({
      top: section.offsetTop - window.innerHeight * 0.03, // 3% above the section
      behavior: "smooth",
    });

    // Animation class
    section.classList.add("section-animate");

    // Remove animation class after animation ends
    setTimeout(() => {
      section.classList.remove("section-animate");
    }, 600);
  };

  return (
    <motion.nav
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      className="navbar"
    >
      <div className="nav-container">

        <div className="logo" onClick={() => navigate("/")}>
          <img src={logo} alt="Dhanushdhari Developers Logo" className="logo-image" />
          Dhanushdhari Developers
        </div>

        <div className={`nav-links ${open ? "open" : ""}`}>
          {/* <a onClick={() => scrollToSection("hero")}>Home</a> */}
           <a onClick={() => navigate("/services")}>Services</a>
          <a onClick={() =>{
            navigate("/#projects");
            
          } }>Available Property</a>
          <a onClick={() =>{
            navigate("/#about");
            
          } }>About</a>
          <a onClick={() =>{
            navigate("/#contact");
            
          } }>Contact</a>
          <a onClick={() =>{
            navigate("/gallery");
            
          } }>Gallery</a>


            <div onClick={()=>{isAuthenticated?navigate("/profile"):navigate("/login")}}>
        <img src="/user.png"
        style={{backgroundColor:"#fefefe",borderRadius:"50%"}}/>
        </div>
        </div>

        <div className={`hamburger ${open ? "active" : ""}`} onClick={() => setOpen(!open)}>
          <span></span><span></span><span></span>
        </div>

      </div>
    </motion.nav>
  );
}
